import URI from 'urijs'
import { API_BASE } from 'shared/constants/Api'

export const EMPLOYEES_LIST = (params) => URI(`${API_BASE}/api/v3/employees/se/`).addSearch(params)
export const EMPLOYEE = (id) => `${API_BASE}/api/v3/employees/se/${id}/`
export const BENEFITS_LIST = (employeeId) => EMPLOYEE(employeeId) + 'benefits/'
export const BENEFIT = (employeeId, benefitId) => BENEFITS_LIST(employeeId) + `${benefitId}/`
